
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import ModelFile from '../../assets/PwsLine03.glb';
export function PwsLineModel03(props) {
  const { nodes, materials } = useGLTF(ModelFile);
  return (
    <group {...props} dispose={null}>
      <group position={[1.999, 0, -9.343]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <group position={[1.25, 0, 200]}>
          <mesh geometry={nodes.Box_11.geometry} material={materials.Autumn} position={[0, 0, 1200]} scale={[10, 3, 0.25]} />
          {/* <mesh geometry={nodes.Box_7_1.geometry} material={materials.Autumn} position={[0, 0, 800]} scale={[10, 3, 0.25]} /> */}
          {/* <mesh geometry={nodes.Box_8_1.geometry} material={materials.Autumn} position={[0, 0, 400]} scale={[10, 3, 0.25]} /> */}
          <mesh geometry={nodes.Box_9.geometry} material={materials.Autumn} scale={[10, 3, 0.25]} />
        </group>
        <group position={[-1.25, -2.5, 0]}>
          <mesh geometry={nodes.Box_13.geometry} material={materials['Fall Chill']} position={[-487.5, -132.5, 0]} scale={[0.25, 0.25, 15]} />
          <mesh geometry={nodes.Box_12.geometry} material={materials['Fall Chill']} position={[487.5, -132.5, 0]} scale={[0.25, 0.25, 15]} />
          <mesh geometry={nodes.Box_14.geometry} material={materials['Fall Chill']} position={[-487.5, 132.5, 0]} scale={[0.25, 0.25, 15]} />
          <mesh geometry={nodes.Box_10.geometry} material={materials['Fall Chill']} position={[487.5, 132.5, 0]} scale={[0.25, 0.25, 15]} />
        </group>
      </group>
      <group position={[1.181, 0, -4.65]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_6'
        })} geometry={nodes.Box_6.geometry} material={materials['Fresh Scent']} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Op_4'
        })} geometry={nodes.Op_4.geometry} material={materials.Fiesta} position={[0, -4009.236, 0]} scale={[4, 4, 0.01]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Op_3'
        })} geometry={nodes.Op_3.geometry} material={materials.Fiesta} position={[0, -2319.654, 0]} scale={[4, 4, 0.01]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Op_2'
        })} geometry={nodes.Op_2.geometry} material={materials.Fiesta} position={[0, -605.878, 0]} scale={[4, 4, 0.01]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Op_1'
        })} geometry={nodes.Op_1.geometry} material={materials.Fiesta} position={[0, 886.843, 0]} scale={[4, 4, 0.01]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Op_5'
        })} geometry={nodes.Op_5.geometry} material={materials.Fiesta} position={[0, 2425.783, 0]} scale={[4, 4, 0.01]} />
        {/* <mesh geometry={nodes.Op_5_1.geometry} material={materials.Fiesta} position={[0, 4009.236, 0]} scale={[4, 4, 0.01]} /> */}
      </group>
      <group position={[0.556, 1.05, -4.348]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh geometry={nodes.BlueBin_7.geometry} material={materials['Magic Spell 5']} position={[20.186, 3284.131, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_6.geometry} material={materials['Magic Spell 5']} position={[-44.409, 1758.088, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_5.geometry} material={materials['Magic Spell 5']} position={[4.037, 1063.698, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_4.geometry} material={materials['Magic Spell 5']} position={[-20.186, -179.01, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_3.geometry} material={materials['Magic Spell 5']} position={[-44.409, -1230.657, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_2.geometry} material={materials['Magic Spell 5']} position={[44.409, -2387.142, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_1.geometry} material={materials['Magic Spell 5']} position={[-28.26, -3060.67, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_13.geometry} material={materials['Magic Spell 5']} position={[-4.037, 2905.543, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_12.geometry} material={materials['Magic Spell 5']} position={[-4.037, 2246.28, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_11.geometry} material={materials['Magic Spell 5']} position={[-4.037, 554.844, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_10.geometry} material={materials['Magic Spell 5']} position={[-4.037, 291.725, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_9.geometry} material={materials['Magic Spell 5']} position={[-4.037, -420.126, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin_8.geometry} material={materials['Magic Spell 5']} position={[-4.037, -2624.088, 0]} scale={[0.721, 0.37, 0.682]} />
        <mesh geometry={nodes.BlueBin.geometry} material={materials['Magic Spell 5']} position={[-4.037, -3284.131, 0]} scale={[0.721, 0.37, 0.682]} />
      </group>
      <group position={[0.287, 1.039, -4.506]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh geometry={nodes.GreenBin_6.geometry} material={materials['Magic Spell 4']} position={[-65.703, -1843.507, 90.968]} rotation={[0, 0.64, 0]} />
        <mesh geometry={nodes.GreenBin_5.geometry} material={materials['Magic Spell 4']} position={[-65.703, -4155.937, 90.968]} rotation={[0, 0.64, 0]} />
        <mesh geometry={nodes.GreenBin_4.geometry} material={materials['Magic Spell 4']} position={[-65.703, -4155.937, 90.968]} rotation={[0, 0.64, 0]} />
        <mesh geometry={nodes.GreenBin_3.geometry} material={materials['Magic Spell 4']} position={[-65.703, 4155.937, 90.968]} rotation={[0, 0.64, 0]} />
        <mesh geometry={nodes.GreenBin_2.geometry} material={materials['Magic Spell 4']} position={[-65.703, 2029.452, 90.968]} rotation={[0, 0.64, 0]} />
        <mesh geometry={nodes.GreenBin_1.geometry} material={materials['Magic Spell 4']} position={[-65.703, 267.942, 90.968]} rotation={[0, 0.64, 0]} />
        <mesh geometry={nodes.GreenBin.geometry} material={materials['Magic Spell 4']} position={[-65.703, -691.585, 90.968]} rotation={[0, 0.64, 0]} />
      </group>
      <group position={[0.36, 1.04, -6.9]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'SidePlate_1'
        })} geometry={nodes.SidePlate_1.geometry} material={materials['Victoria 1']} position={[-200, -80, 10]} scale={[1.4, 0.2, 5]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'SidePlate'
        })} geometry={nodes.SidePlate.geometry} material={materials['Victoria 2']} position={[-200, 80, 10]} scale={[1.4, 0.2, 5]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_3'
        })} geometry={nodes.Box_3.geometry} material={materials['Electric Glow 1']} position={[-90, 0, 520]} scale={[1, 1, 3]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_2'
        })} geometry={nodes.Box_2.geometry} material={materials['Serena 1']} position={[-260, 0, 0]} scale={[0.2, 1.8, 5]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_4'
        })} geometry={nodes.Box_4.geometry} material={materials['Placebo 3']} position={[0, -355, -1170]} scale={[1.765, 0.633, 0.2]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box'
        })} geometry={nodes.Box.geometry} material={materials['Placebo 1']} position={[0, -560, -1190]} scale={[1.765, 1, 0.2]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_1'
        })} geometry={nodes.Box_1.geometry} material={materials['Placebo 2']} position={[-100, -340, -690]} scale={[0.882, 0.6, 0.2]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_5'
        })} geometry={nodes.Box_5.geometry} material={materials.Lola} position={[180, 0, 40]} scale={[2, 2, 1]} />
      </group>
      <group position={[0.36, 1.04, -8.2]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'SidePlate_1_1'
        })} geometry={nodes.SidePlate_1_1.geometry} material={materials['Victoria 1']} position={[-200, -80, 10]} scale={[1.4, 0.2, 5]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'SidePlate_2'
        })} geometry={nodes.SidePlate_2.geometry} material={materials['Victoria 2']} position={[-200, 80, 10]} scale={[1.4, 0.2, 5]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_3_1'
        })} geometry={nodes.Box_3_1.geometry} material={materials['Electric Glow 1']} position={[-90, 0, 520]} scale={[1, 1, 3]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_2_1'
        })} geometry={nodes.Box_2_1.geometry} material={materials['Serena 1']} position={[-260, 0, 0]} scale={[0.2, 1.8, 5]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_4_1'
        })} geometry={nodes.Box_4_1.geometry} material={materials['Placebo 3']} position={[0, -355, -1170]} scale={[1.765, 0.633, 0.2]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_7'
        })} geometry={nodes.Box_7.geometry} material={materials['Placebo 1']} position={[0, -560, -1190]} scale={[1.765, 1, 0.2]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_1_1'
        })} geometry={nodes.Box_1_1.geometry} material={materials['Placebo 2']} position={[-100, -340, -690]} scale={[0.882, 0.6, 0.2]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_5_1'
        })} geometry={nodes.Box_5_1.geometry} material={materials.Lola} position={[180, 0, 40]} scale={[2, 2, 1]} />
      </group>
      <group position={[0.36, 1.04, -2.19]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'SidePlate_1_2'
        })} geometry={nodes.SidePlate_1_2.geometry} material={materials['Victoria 1']} position={[-200, -80, 10]} scale={[1.4, 0.2, 5]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'SidePlate_3'
        })} geometry={nodes.SidePlate_3.geometry} material={materials['Victoria 2']} position={[-200, 80, 10]} scale={[1.4, 0.2, 5]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_3_2'
        })} geometry={nodes.Box_3_2.geometry} material={materials['Electric Glow 1']} position={[-90, 0, 520]} scale={[1, 1, 3]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_2_2'
        })} geometry={nodes.Box_2_2.geometry} material={materials['Serena 1']} position={[-260, 0, 0]} scale={[0.2, 1.8, 5]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_4_2'
        })} geometry={nodes.Box_4_2.geometry} material={materials['Placebo 3']} position={[0, -355, -1170]} scale={[1.765, 0.633, 0.2]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_8'
        })} geometry={nodes.Box_8.geometry} material={materials['Placebo 1']} position={[0, -560, -1190]} scale={[1.765, 1, 0.2]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_1_2'
        })} geometry={nodes.Box_1_2.geometry} material={materials['Placebo 2']} position={[-100, -340, -690]} scale={[0.882, 0.6, 0.2]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_5_2'
        })} geometry={nodes.Box_5_2.geometry} material={materials.Lola} position={[180, 0, 40]} scale={[2, 2, 1]} />
      </group>
      <group position={[0.49, 1.04, -5.16]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <group position={[-90, 0, 10]}>
          <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'SidePlate_1_3'
        })} geometry={nodes.SidePlate_1_3.geometry} material={materials.Victoria} position={[0, -140, 0]} scale={[1, 0.2, 5]} />
          {/* <mesh geometry={nodes.SidePlate_4.geometry} material={materials.Victoria} position={[0, 140, 0]} scale={[1, 0.2, 5]} /> */}
        </group>
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_3_3'
        })} geometry={nodes.Box_3_3.geometry} material={materials['Electric Glow']} position={[20, 0, 520]} scale={[1, 1, 3]} />
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_2_3'
        })} geometry={nodes.Box_2_3.geometry} material={materials.Serena} position={[-150, 0, 0]} scale={[0.2, 3, 5]} />
        {/* <mesh geometry={nodes.Box_15.geometry} material={materials.Placebo} position={[10, -560, -1190]} scale={[0.882, 1, 0.2]} /> */}
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Box_1_3'
        })} geometry={nodes.Box_1_3.geometry} material={materials.Placebo} position={[10, -560, -690]} scale={[0.882, 1, 0.2]} />
      </group>
      <group position={[0.427, 1.053, -0.799]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh onClick={() => props.openDetail({
          typ: 'dynamicZenChart',
          objectId: 'Merged_Objects_1'
        })} geometry={nodes.Merged_Objects_1.geometry} material={materials.Victoria} position={[-37.759, -30.04, -17.56]} />
      </group>
      <group position={[0, 0, -1.5]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh geometry={nodes.FrameTop.geometry} material={materials['Nickel Satin']} position={[212.5, 711.25, 2175]} />
        <mesh geometry={nodes.FrameTable.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 975]} />
        <mesh geometry={nodes.TableTop.geometry} material={materials['Afternoon 8']} position={[0, 708.75, 1030]} rotation={[Math.PI / 2, Math.PI / 2, 0]} scale={[12.955, 0.1, 2.258]} />
        <mesh geometry={nodes.Legs.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 0]} />
      </group>
      <group position={[0, 0, -7.5]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh geometry={nodes.FrameTop_1.geometry} material={materials['Nickel Satin']} position={[212.5, 711.25, 2175]} />
        <mesh geometry={nodes.FrameTable_1.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 975]} />
        <mesh geometry={nodes.Legs_1.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 0]} />
        <mesh geometry={nodes.TableTop_1.geometry} material={materials['Afternoon 8']} position={[0, 708.75, 1030]} rotation={[Math.PI / 2, Math.PI / 2, 0]} scale={[12.955, 0.1, 2.258]} />
      </group>
      <group position={[0, 0, -6]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh geometry={nodes.FrameTop_2.geometry} material={materials['Nickel Satin']} position={[212.5, 711.25, 2175]} />
        <mesh geometry={nodes.FrameTable_2.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 975]} />
        <mesh geometry={nodes.Legs_2.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 0]} />
        <mesh geometry={nodes.TableTop_2.geometry} material={materials['Afternoon 8']} position={[0, 708.75, 1030]} rotation={[Math.PI / 2, Math.PI / 2, 0]} scale={[12.955, 0.1, 2.258]} />
      </group>
      <group position={[0, 0, -4.5]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh geometry={nodes.FrameTop_3.geometry} material={materials['Nickel Satin']} position={[212.5, 711.25, 2175]} />
        <mesh geometry={nodes.FrameTable_3.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 975]} />
        <mesh geometry={nodes.Legs_3.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 0]} />
        <mesh geometry={nodes.TableTop_3.geometry} material={materials['Afternoon 8']} position={[0, 708.75, 1030]} rotation={[Math.PI / 2, Math.PI / 2, 0]} scale={[12.955, 0.1, 2.258]} />
      </group>
      <group position={[0, 0, -3]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh geometry={nodes.FrameTop_4.geometry} material={materials['Nickel Satin']} position={[212.5, 711.25, 2175]} />
        <mesh geometry={nodes.FrameTable_4.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 975]} />
        <mesh geometry={nodes.Legs_4.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 0]} />
        <mesh geometry={nodes.TableTop_4.geometry} material={materials['Afternoon 8']} position={[0, 708.75, 1030]} rotation={[Math.PI / 2, Math.PI / 2, 0]} scale={[12.955, 0.1, 2.258]} />
      </group>
      <group rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <mesh geometry={nodes.FrameTop_5.geometry} material={materials['Nickel Satin']} position={[212.5, 711.25, 2175]} />
        <mesh geometry={nodes.FrameTable_5.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 975]} />
        <mesh geometry={nodes.Legs_5.geometry} material={materials['Nickel Satin']} position={[350, 711.25, 0]} />
        <mesh onClick={() => props.openDetail({
        typ: 'widget',
        objectId: 'TableTop_5'
      })} geometry={nodes.TableTop_5.geometry} material={materials['Afternoon 8']} position={[0, 708.75, 1030]} rotation={[Math.PI / 2, Math.PI / 2, 0]} scale={[12.955, 0.1, 2.258]} />
      </group>
      <mesh onClick={() => props.openDetail({
        typ: 'widget',
        objectId: 'Board'
      })} geometry={nodes.Board.geometry} material={materials.Namibia} position={[0.209, 1.725, 0]} rotation={[-Math.PI / 2, 0, 0]} scale={[0.005, 0, 0.005]} />
      <mesh onClick={() => props.openDetail({
        typ: 'dynamicZenChart',
        objectId: 'Merged_Objects'
      })} geometry={nodes.Merged_Objects.geometry} material={materials['Magic Spell 4']} position={[2.01, 0.232, -9.312]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001} />
      <mesh onClick={() => props.openDetail({
        typ: 'dynamicZenChart',
        objectId: 'Merged_Objects_2'
      })} geometry={nodes.Merged_Objects_2.geometry} material={materials.Victoria} position={[0.49, 1.04, -3.42]} rotation={[-Math.PI / 2, 0, 0]} scale={0.001} />
    </group>
  )
}

// useGLTF.preload(ModelFile)
